import React, { useEffect, useState } from "react";
import { Box, Typography, Button, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import {
  fetchItCategory,
  fetchApplicationCategories,
  addItCategoryApplicationCategory,
} from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { COMPANY_ID } from "../../config/appConfig";

export default function ItCategoryApplicationCategoryAddPage() {
  const { businessDomainId, categoryId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [applicationCategories, setApplicationCategories] = useState([]);
  const [selectedId, setSelectedId] = useState("");

  const basePath = `/strategy/${businessDomainId}/it-categories/${categoryId}`;

  useEffect(() => {
    (async () => {
      try {
        const [cat, all] = await Promise.all([
          fetchItCategory(categoryId),
          fetchApplicationCategories(COMPANY_ID),
        ]);
        const existing = new Set((cat.applicationCategories || []).map((ac) => ac.applicationCategoryId));
        setApplicationCategories((Array.isArray(all) ? all : []).filter((ac) => !existing.has(ac.applicationCategoryId)));
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedId) {
      notify.error(t("itCategory.applicationCategory.selectRequired"));
      return;
    }
    try {
      const res = await addItCategoryApplicationCategory(categoryId, selectedId);
      if (res?.result === "NG") {
        notify.error(res.errorMessage || t("message.create.error"));
        return;
      }
      notify.success(t("message.create.success"));
      navigate(`${basePath}/application-categories`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("itCategory.applicationCategories")}：{t("common.add")}
      </Typography>
      <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 480 }}>
        <FormControl fullWidth required sx={{ mb: 3 }}>
          <InputLabel>{t("itCategory.applicationCategoryName")}</InputLabel>
          <Select value={selectedId} onChange={(e) => setSelectedId(e.target.value)}
            label={t("itCategory.applicationCategoryName")}>
            {applicationCategories.map((ac) => (
              <MenuItem key={ac.applicationCategoryId} value={ac.applicationCategoryId}>
                {ac.applicationCategoryName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`${basePath}/application-categories`)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
